module.exports = __webpack_public_path__ + "housingStatic/img/znjqr.fcf3e81.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home_png/znjqr.png
// module id = ttQQ
// module chunks = 2